export default "__VITE_PUBLIC_ASSET__3ba82ce2__"